import type { RouteDefinition } from "../../routes/routes";
import { ReportCard, ReportCardOverview } from "./ReportCard";

export const ReportCardRoutes: RouteDefinition[] = [
  {
    path: "/staff/reportcard",
    layout: "/user",
    application: "Admin",
    children: [
      {
        path: "/user/staff/reportcard/",
        component: ReportCardOverview,
        exact: true,
      },
      {
        path: "/user/staff/reportcard/:org_id/",
        component: ReportCard,
        exact: true,
      },
    ],
  },
];
